import * as moment from 'moment';

import { SCHEDULE_CONSTANTS } from '@finder/shared/constants/app.constants';

/* istanbul ignore next */
/**
 * @name        getDateString
 * @description Outputs the date provided (or today if no date provided) as a formatted string.
 * @param       {Date} date the date to convert
 * @returns     {string} the date formatted as a string
 */
function getDateString(date: Date = new Date()): string {
    return moment(date).format(SCHEDULE_CONSTANTS.scheduleDateFormat);
}

export default getDateString;
